import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { DataEntryAccidentStepSectionProps } from "src/types";
import { useYesNoAnswer } from "src/utils";

export const useDataEntryAccidentStepMaterialDamages = ({
  formik,
}: DataEntryAccidentStepSectionProps) => {
  const { t } = useTranslation();
  const { yesNoOptions } = useYesNoAnswer();

  const { setFieldValue, setFieldError, setFieldTouched } = formik;

  const onSelectOtherVehiclesDamagedQuestion = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const otherVehiclesDamagedQuestion = event.target.value;
    if (!otherVehiclesDamagedQuestion) return;

    setFieldValue("accidentData.materialDamages.otherVehiclesDamageDetails", "");
    setFieldError("accidentData.materialDamages.otherVehiclesDamageDetails", "");
    setFieldTouched("accidentData.materialDamages.otherVehiclesDamageDetails", false, false);
  };

  const onSelectOtherObjectsDamagedQuestion = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const otherObjectsDamagedQuestion = event.target.value;
    if (!otherObjectsDamagedQuestion) return;

    setFieldValue("accidentData.materialDamages.otherObjectsDamageDetails", "");
    setFieldError("accidentData.materialDamages.otherObjectsDamageDetails", "");
    setFieldTouched("accidentData.materialDamages.otherObjectsDamageDetails", false, false);
  };

  return {
    yesNoOptions,
    t,
    onSelectOtherVehiclesDamagedQuestion,
    onSelectOtherObjectsDamagedQuestion,
  };
};
